import Draggable from 'vuedraggable';

import contentMixin from '@/mixins/templates/content';
import ColorAndIconMixin from '@/mixins/content-icon-color.js';
import getIsTouchDeviceMixins from '@/mixins/check-is-touch-device';

import ContentType from '@/helpers/contentType';
import AcademicMainType from '@/helpers/academicMainType';
import { SCORM_UPLOAD_STATUS } from '@/helpers/scorm';
import { PROCESSING_STATUS } from '@/helpers/avaliaActivity';

import TopicSettingsMenu from '@/components/content-v2/templates/common/topic-settings-menu';
import ContentSyncMixin from '@/mixins/content-sync';

export default {
  mixins : [ColorAndIconMixin, contentMixin, getIsTouchDeviceMixins, ContentSyncMixin],
  props  : {
    context: {
      type: Object,
      default() {
        return {};
      }
    },
    isStudent: {
      type    : Boolean,
      default : true
    }
  },
  components: {
    TopicSettingsMenu,
    Draggable
  },
  data() {
    return {
      AcademicMainType,
      isHoveringSettingsButton: false
    };
  },
  methods: {
    hadCompletedProgress(topic) {
      return (
        this.isStudent &&
        this.context.academicMainTypeId !== this.AcademicMainType.COMMUNITY &&
        topic.isRecordProgress &&
        topic.viewed &&
        !topic.isBlockedContentByConditional
      );
    },
    isDeadlineLabelVisible(topic) {
      if (this.isStudent && topic.topicTypeId === ContentType.AVALIA && !topic.content.isActive) {
        return false;
      }

      if (this.context.hasDeadline && this.context.deadlineAt) {
        return topic.hasDeadline && this.$options.filters.formatDate(topic.deadlineAt) !== this.$options.filters.formatDate(this.context.deadlineAt);
      }

      return topic.hasDeadline && topic.deadlineAt;
    },
    isTopicDeadlineExpired(topic) {
      return this.isStudent
        && topic.hasOwnProperty('isBeforeDeadline')
        && !topic.isBeforeDeadline
        && topic.expired;
    },
    scormStatus(topic) {
      const props = {
        show: false
      };

      if (this.isStudent || topic.topicTypeId !== ContentType.SCORM) {
        return props;
      }

      if (topic.content.uploadStatus === SCORM_UPLOAD_STATUS.ERROR) {
        props.show = true;
        props.message = this.$t('contentType.scorm.tagStatusTextError');
        props.color = 'var(--v-error-base)';
        props.icon = 'mdi-alert';
      } else if (topic.content.uploadStatus === SCORM_UPLOAD_STATUS.RUNNING) {
        props.show = true;
        props.message = this.$t('contentType.scorm.tagStatusTextProcessing');
        props.color = 'var(--v-warning-base)';
        props.icon = 'mdi-progress-clock';
      }

      return props;
    },
    isWConferenceNotIntegrated(topic) {
      return topic.topicTypeId === ContentType.WEBCONFERENCE && !topic.content.isIntegrated;
    },
    isAvaliaAndInactive(topic) {
      return (
        topic.topicTypeId === ContentType.AVALIA &&
        (!topic.content.isActive || topic.content.status !== PROCESSING_STATUS.OK)
      );
    },
    statusChip(topic) {
      const props = {
        show: false
      };
      
      if (this.isStudent) {
        return props;
      }

      if (this.isAvaliaAndInactive(topic)) {
        props.show = true;
        props.message = this.$t('contentType.scorm.tagStatusTextProcessing');
        props.color = 'var(--v-warning-base)';
        props.icon = 'mdi-progress-clock';
      } else if (this.isWConferenceNotIntegrated(topic)) {
        props.show = true;
        props.message = this.$t('contentType.scorm.tagStatusTextError');
        props.color = 'var(--v-error-base)';
        props.icon = 'mdi-alert';
      }

      return props;
    }
  }
};
